<template>
  <div id="update-card-list">
      <v-card class="grey darken-4">
        <v-card-title primary-title><h1>Updates</h1></v-card-title>
        <v-responsive>
          <v-container fluid v-bind="{ [`grid-list-md`]: true }">
            <v-layout row wrap>
              <v-flex xs12 lg4 v-for="update in Updates" :key="update.img">
                <update-card  :update="update"></update-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-responsive>
      </v-card>
  </div>
</template>

<script>
import FeedUpdateStore from '../../../stores/FeedUpdateStore.js'
import UpdateCard from '../../../components/cards/UpdateCard.vue'

export default {
  data () {
    return {
      Updates: FeedUpdateStore.data.updates
    }
  },

  components: {
    'update-card': UpdateCard
  }  
}
</script>



// WEBPACK FOOTER //
// src/layouts/dashboard/lists/CardList.vue